import { createContext, useState } from "react";

/** MyMine Version3.0 新規追加
* Notify Context
*/
export const NotifyContext = createContext({});

export const NotifyContextProvider = (props) => {
  const [notify, setNotify] = useState(null);

  return (
    <NotifyContext.Provider value={{ notify, setNotify }}>
      {props.children}
    </NotifyContext.Provider>
  );
};